import queryString from "query-string";

export default (url, params, type, signal) => {
  const fetchURL =
    url + (!url.indexOf("?") > 0 ? "&" : "?") + queryString.stringify(params);

  return fetch(fetchURL, { signal })
    .then((response) => response.json())
    .then((data) => {
      if (type === "default" || type === undefined) {
        const results =
          data &&
          data.results &&
          data.results.map((result) => {
            return {
              ...result,
              cta: {
                href: result.contentUrl || "",
                type: result.urlType || "",
              },
              image: {
                alt: "",
                sources: result.imageSrc
                  ? [result.imageSrc]
                  : result.imageFormat === 1 && result.imageSrc1x1
                    ? [result.imageSrc1x1]
                    : result.imageFormat === 2 && result.imageSrc16x9
                      ? [result.imageSrc16x9]
                      : [],
              },
              image1x1: {
                alt: "",
                sources: result.imageSrc1x1 ? [result.imageSrc1x1] : [],
              },
              image16x9: {
                alt: "",
                sources: result.imageSrc16x9 ? [result.imageSrc16x9] : [],
              },
            };
          });

        return { ...data, results };
      } else if (type === "search-component") {
        const results =
          data &&
          data.results[0].results &&
          data.results[0].results.map((result) => {
            return {
              ...result,
              body: result.summary,
              cta: { href: result.link || "" },
              image: {
                alt: "",
                sources: result.image ? [result.image] : [],
              },
            };
          });

        return {
          ...data,
          grantBox: data.results[0].grantBox,
          sidebar: data.results[0].sidebar,
          results,
        };
      } else {
        return data;
      }
    })
    .catch((err) => {
      if (err.name === "AbortError") {
        return; // Continuation logic has already been skipped, so return normally
      }
      console.error(err);
    });
};
